import "./Footer01.css";

function Footer01() {
  return (
    <header className="Footer01 section">
      <div className="container">
        <div className="Footer01-box">
          <h4>Disclaimer:</h4>
          <p>
            This project is an independent community-driven memecoin built on
            the BSC blockchain. While inspired by the artistic vision of Raphael
            Erba,
            <span>
              this project has no affiliation with, endorsement from, or
              association with the artist
            </span>
            . The use of his name and artistic style is for inspiration and
            community building purposes only.
          </p>
        </div>
      </div>
    </header>
  );
}

export default Footer01;
